<template>
    <div class="socials">
        <paragraph size="L" :content="config.follow" />
        <div class="icons">
            <icon-social
                v-for="(link, name) in $json.socials"
                size="S"
                :name="name"
                :link="link"
                :key="name"
            />
        </div>
    </div>
</template>

<script>
import Paragraph from 'gvue/src/core/Paragraph'
import IconSocial from '@/components/common/IconSocial'

export default {
    name: 'FooterSocials',
    components: {
        Paragraph,
        IconSocial
    },
    computed: {
        config() {
            return this.$json.config
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables

.socials
    [class*="g_txt"]
        font-weight: 700
        opacity: 0.625

.icons
    display: flex
    align-items: center

+mobile
    .socials
        text-align: center

    .icons
        margin-top: $gap

+desktop

    .socials
        display: flex
        align-items: center

    .social
        &:first-of-type
            margin-left: ($gap * 0.625)
</style>
